import { BID_STATUS } from "@vahak/core/dist/constants/bidStatus";

export const AssuredBidStatusList = [BID_STATUS.STAND_BY, BID_STATUS.PARTIALLY_ACCEPTED];
